export { default } from './Heading';
export type { Props } from './Heading';



// WEBPACK FOOTER //
// ../kibble/components/Heading/index.ts